<template>
  <bottom-sheet-overflow-button :bottom-sheet-component="sheetComponent" :menu-items="menuItems"
                                :component-props="{ menuItems, sheetProps: {disabled: isLoading} }" :menuButtonColor="menuButtonColor"/>
</template>

<script>
import Segment from '@/Segment';
import BaseUi from '@riseupil/base-ui';
import ClickOutside from '@/directives/click-outside';
import { mapActions, mapGetters } from 'vuex';
import DeleteCredsPopup from '@/base-components/credentials/credentials-list/DeleteCredsPopup';
import UpdateAccountNamePopup from '@/base-components/credentials/credentials-list/UpdateAccountNamePopup';
import AggregatorApi from '@/api/AggregatorApi';
import DDLogs from '@/DDLogs';
import BottomSheetOverflowButton from '@/base-components/BottomSheetOverflowButton';
import AddCredentialsFlow
  from '@/pages/responsive-pages/authenticated/navigation-pages/credentials-settings/add-credentials-flow/AddCredentialsFlow';
import AgentsUtls from '@/utils/agentsUtils';
import SimpleBottomSheetMenu from '@/base-components/SimpleBottomSheetMenu';
import _ from 'lodash';
import CredentialsApi from '@/api/CredentialsApi';
import BrowserInfo from '@/mixins/BrowserInfo.vue';
import { externalLinkRedirect } from '@/router';

export default {
  name: 'CredentialsMenu',
  directives: {
    ClickOutside,
  },
  components: {
    BottomSheetOverflowButton,
  },
  props: {
    source: {
      type: Object,
      required: true,
    },
  },
  mixins: [BrowserInfo],
  data() {
    return {
      isLoading: false,
      sheetComponent: SimpleBottomSheetMenu,
      menuButtonColor: BaseUi.Colors.riseupWhite,
      deleteItem: {
        text: 'מחיקת חיבור',
        onClick: this.emitDeleteCredsPopup,
        iconProps: {
          iconName: 'delete',
          fill: true,
        },
      },
      editItem: {
        text: 'עריכת כינוי',
        onClick: this.emitAccountNicknamePopup,
        iconProps: {
          iconName: 'edit',
          fill: true,
        },
      },
      menuOpen: false,
    };
  },
  computed: {
    ...mapGetters('credentials', ['enableCredentialsActions']),
    ...mapGetters('featureFlags', ['enableAccountNickname']),
    ...mapGetters('subscriptionState', ['isDormant']),
    isOpenBanking() {
      return this.source && !!this.source.openBankingConsentId;
    },
    consentRenewal() {
      return `לחידוש ההסכמה ב${this.sourceName}`;
    },
    sourceName() {
      return this.source.sourceName === 'לאומי קארד' ? 'מקס' : this.source.sourceName;
    },
    renewConsentItem() {
      return this.isOpenBanking && !this.isDormant && {
        text: this.consentRenewal,
        onClick: this.renewConsent,
        disabled: this.source.displayIncidentTooltip,
        loading: this.isLoading,
        keepOpenOnClick: true,
        iconProps: {
          iconName: 'open_in_new',
        },
      };
    },
    menuItems() {
      return _.compact([
        this.renewConsentItem,
        this.editItem,
        this.deleteItem,
      ]);
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal', 'changeCurrentModalProps']),
    async renewConsent() {
      if (this.source.openBanking.allowDesktop === false && !AgentsUtls.isMobile()) {
        this.openModal({
          component: AddCredentialsFlow,
          props: {
            sourceNameToAdd: this.source.sourceName,
          },
          popupAlignment: 'full-screen',
        });
        Segment.trackUserInteraction(
          'RenewConsentOBKClickedFormNotAllowedDesktop',
          { credentialsId: this.source.credentialsId, source: this.source.sourceName },
        );
      } else {
        this.isLoading = true;
        Segment.trackUserInteraction('RenewConsentOBKClicked', {
          credentialsId: this.source.credentialsId,
          source: this.source.sourceName,
        });
        const url = await AggregatorApi.updateConsent(
          this.source.openBanking.aggregatorBankId,
          this.source.openBankingConsentId,
          this.source.credentialsId,
        );
        await CredentialsApi.createOBKConnectionRequestEvent({
          consentId: this.source.openBankingConsentId,
          previousConsentId: this.source.previousConsentId,
          sourceName: this.source.sourceName,
          browserInfo: await this.getBrowserParams(),
        });
        DDLogs.log('Redirecting to OpenBanking', { url });
        externalLinkRedirect(url);
        this.isLoading = false;
      }
    },
    emitDeleteCredsPopup() {
      Segment.trackUserInteraction('SectionMenu_DeleteCredsClicked');
      this.openModal({
        component: DeleteCredsPopup,
        props: { source: this.source },
      });
    },
    emitAccountNicknamePopup() {
      Segment.trackUserInteraction('SectionMenu_AccountNicknameClicked');
      this.menuOpen = true;
      this.openModal({
        component: UpdateAccountNamePopup,
        props: { source: this.source },
        eventHandlers: {
          close: () => {
            this.menuOpen = false;
          },
        },
      });
    },
  },
  watch: {
    source(newSource) {
      if (this.menuOpen) {
        this.changeCurrentModalProps({ props: { source: newSource } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
